(function () {
  'use strict';

  if (window.__ryAttributionPersistenceLoaded) return;
  window.__ryAttributionPersistenceLoaded = true;

  var FIRST_KEY = 'ry_attribution_first_v2';
  var LAST_KEY = 'ry_attribution_last_non_direct_v2';
  var PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'fbclid',
    'oppref'
  ];

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(
        privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true
      );
    } catch (error) {
      return false;
    }
  }

  function read(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || 'null');
    } catch (error) {
      return null;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function externalReferrer() {
    if (!document.referrer) return '';
    try {
      var referrer = new URL(document.referrer);
      var referrerHost = referrer.hostname.replace(/^www\./, '');
      var currentHost = window.location.hostname.replace(/^www\./, '');
      return referrerHost === currentHost ? '' : document.referrer;
    } catch (error) {
      return '';
    }
  }

  function currentTouch() {
    var query = new URLSearchParams(window.location.search);
    var touch = {
      landing_page: window.location.pathname + window.location.search,
      referrer: externalReferrer(),
      captured_at: new Date().toISOString()
    };
    var hasCampaign = false;

    PARAMS.forEach(function (key) {
      var value = (query.get(key) || '').trim();
      touch[key] = value;
      if (value) hasCampaign = true;
    });

    touch.has_campaign = hasCampaign;
    return touch;
  }

  function persist() {
    if (!analyticsAllowed()) return null;

    var touch = currentTouch();
    var attributable = touch.has_campaign || Boolean(touch.referrer);
    var first = read(FIRST_KEY);
    var last = read(LAST_KEY);

    if (!first && attributable) {
      first = touch;
      write(FIRST_KEY, first);
    }
    if (attributable) {
      last = touch;
      write(LAST_KEY, last);
    }

    return { first: first, last: last || first };
  }

  function hidden(form, name, value) {
    if (!form || !value) return;
    var field = form.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = String(value).slice(0, 255);
  }

  function applyTouch(form, prefix, touch) {
    if (!touch) return;
    var map = {
      utm_source: 'Source',
      utm_medium: 'Medium',
      utm_campaign: 'Campaign',
      utm_content: 'Content',
      utm_term: 'Term',
      gclid: 'Google click ID',
      fbclid: 'Meta click ID',
      oppref: 'OpenAI click reference',
      landing_page: 'Landing page',
      referrer: 'Referrer',
      captured_at: 'Captured at'
    };

    Object.keys(map).forEach(function (key) {
      if (touch[key]) hidden(form, prefix + map[key] + ']', touch[key]);
    });
  }

  function applyToForm(form, attribution) {
    if (!form || !attribution) return;
    var action = form.getAttribute('action') || '';
    var isCartAdd = action.indexOf('/cart/add') !== -1;
    var isCart = /\/cart(?:\?|$)/.test(action);
    if (!isCartAdd && !isCart) return;

    var prefix = isCartAdd ? 'properties[_RY ' : 'attributes[RY ';
    applyTouch(form, prefix + 'First ', attribution.first);
    applyTouch(form, prefix + 'Last non-direct ', attribution.last);
  }

  function applyToForms(attribution) {
    document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
      applyToForm(form, attribution);
    });
  }

  function initialise() {
    if (!analyticsAllowed()) return;
    var attribution = persist();
    applyToForms(attribution);
  }

  function initialiseWhenPrivacyReady(attempt) {
    if (analyticsAllowed()) {
      initialise();
      return;
    }
    if (attempt >= 4) return;
    window.setTimeout(function () {
      initialiseWhenPrivacyReady(attempt + 1);
    }, [250, 750, 2000, 5000][attempt]);
  }

  document.addEventListener('submit', function (event) {
    if (!analyticsAllowed()) return;
    applyToForm(event.target, persist());
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseWhenPrivacyReady(0);
    }, { once: true });
  } else {
    initialiseWhenPrivacyReady(0);
  }
  document.addEventListener('visitorConsentCollected', function () {
    initialiseWhenPrivacyReady(0);
  });
  document.addEventListener('shopify:section:load', function () {
    initialiseWhenPrivacyReady(0);
  });
}());
